import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addFromColumn,
    sortCurrency,
    sortNumber,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import DetailIcon from 'material-ui/svg-icons/image/remove-red-eye';
import TableIcon from 'material-ui/svg-icons/action/grade';

/**
 * Class for displaying Location Sales in a table
 *
 */
class DiscountsVipCostumerTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'VIP Customer Id', key: 'id'},
                {label: 'First Name', key: 'first_name'},
                {label: 'Last Name', key: 'last_name'},
                {label: 'Email', key: 'email'},
                {label: 'Phone Number', key: 'telephone'},
                {label: 'City', key: 'city'},
                {label: 'State', key: 'state'},
                {label: 'Zipcode', key: 'zip'},
                {label: 'Location Registered', key: 'registered_by_client'},
                {label: 'Active', key: 'active'},
                {label: '# Discounts Used', key: 'discount_qty'},
                {label: 'Amount Saved by Discounts', key: 'discount_total'},
            ],
        };
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Update selected table data based on filter
     *
     * @param event
     * @param table
     */
    handleFilterChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    render() {

        const {
            allowLocationSelection,
            endDate,
            loyaltyIconFunction,
            startDate,
            system,
            tableFilename,
            tableKey,
            tableLabel
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('id');
        const iconStyle = (allowLocationSelection) ? tableStyles.tableIconButton : tableStyles.disabledTableIconButton;

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'VIP Customer ID',
                        accessor: 'id',
                        sortMethod: (a, b) => sortNumber(a, b, 'ASC'),
                        Cell: row => (
                            <span>
                        <span>{row.row.id}</span>
                        <DetailIcon
                            onClick={(e) => loyaltyIconFunction(e, row.row)}
                            style={iconStyle}
                        />
                    </span>
                        ),
                        width: 170,
                        style: tableStyles.right
                    },
                    {
                        Header: 'First Name',
                        accessor: 'first_name'
                    },
                    {
                        Header: 'Last Name',
                        accessor: 'last_name'
                    },
                    {
                        Header: 'Email',
                        accessor: 'email',
                        width: 230
                    },
                    {
                        Header: 'Phone Number',
                        accessor: 'telephone',
                        sortMethod: (a, b) => sortNumber(a, b),
                    },
                    {
                        Header: 'City',
                        accessor: 'city'
                    },
                    {
                        Header: 'State',
                        accessor: 'state'
                    },
                    {
                        Header: 'Zipcode',
                        accessor: 'zip',
                        sortMethod: (a, b) => sortNumber(a, b),
                    },
                    {
                        Header: 'Location Registered',
                        accessor: 'registered_by_client',
                        sortMethod: (a, b) => sortNumber(a, b),
                    },
                    {
                        Header: 'Active',
                        accessor: 'active'
                    },
                    {
                        Header: '# Discounts Used',
                        accessor: 'discount_qty',
                        sortMethod: (a, b) => sortNumber(a, b),
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'discount_qty'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>$ Amount Saved<br/>by Discounts</span>),
                        accessor: 'discount_total',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'discount_total'))}
                            </span>
                        )
                    }
                ]
            }

        ];

        return (
            <div>
                {summaryList.length > 0 &&
                <div className="reports-table-container">

                    {/* Table Header */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Button */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={`${tableFilename}-${system}-${dateString}.csv`}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export {tableLabel}
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>{tableLabel}</span>
                        </h3>
                    </div>

                    {/* Tables: Display and Print */}
                    <ReactTable
                        key={`table-${tableFilename}-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortChange(e, this.locationsReacttable)}
                        onFilteredChange={(e) => this.handleFilterChange(e, this.locationsReacttable)}
                        ref={(r) => this.locationsReacttable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-${tableFilename}-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
                }
            </div>
        )
    }
}

DiscountsVipCostumerTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    allowLocationSelection: PropTypes.bool,
    listData: PropTypes.array,
    locationIconFunction: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableFilename: PropTypes.string,
    tableKey: PropTypes.string,
    tableLabel: PropTypes.string
};

DiscountsVipCostumerTable.defaultProps = {
    addField: true,
    endDate: null,
    allowLocationSelection: true,
    startDate: null,
    tableFilename: 'VIP Customers',
    tableKey: 'VIP Customers',
    tableLabel: 'VIP Customers'
};

export default DiscountsVipCostumerTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountsVipCostumerTable.js